import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import AddToCart from '../common/AddToCart';

/* Actions */
import {
} from '../../../redux/actions';

class PackageConfirmation extends Component {

	constructor(props) {
		super(props);
		this.state = {
		};
	}

    componentWillMount() {
		const self = this;
        let isPricingAccess = self.props.isResponsibilityExists("Price");
		// redirect user to home page if user has not access to this page
		if(!isPricingAccess) {
			browserHistory.push('/home');
		} else if (!self.props.state.packages.packageDetails) {
            browserHistory.push('/createpackage');
        }
	}

    handleRedirect(event) {
        event.preventDefault();
        browserHistory.push('/createpackage');
    }

    render() {
        const self = this;
        const { packageDetails } = this.props.state.packages;
        if (!packageDetails) return null;
        const {
            poNumber,
            shippingAddress,
            agreementNumber,
			orderNumber,
        } = packageDetails;
        return (
            <div>
                <h1 className="pageTitle">PACKAGE CONFIRMATION</h1>
                <span style={{fontSize: '20px'}}>Your package has been {self.props.params.whichtype === 'edit' ? 'updated' : 'created'}.</span>
                <br />
                <span id="addpcktocarttitle">
					<AddToCart
						fireGTMTag={this.props.fireGTMTag}
						getPimDataForCartItem={this.props.getPimDataForCartItem}
						getItemTypeByOrderDetails={this.props.getItemTypeByOrderDetails}
						isPackage={true}
						packageName={poNumber}
						orderNumber={orderNumber}
						getZipCode={this.props.getZipCode}
						
						getShippingAddressesDetails={this.props.getShippingAddressesDetails}
						makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices}
						getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
						linkText={"Add This Package To My Cart"}
						orderDetails={packageDetails}
						linkStyle={true}
						customCSSClass="addPackageToClass"
					/>
                </span>
                <form name="confirmationPackageFrm" id="confirmationPackageFrmId" action="tbd" method="POST">
                    <div className="fullCell">
                        <table id="packageInfoTable">
                            <tbody>
                                <tr>
                                    <td>
                                        <span style={{fontWeight: 'bold'}}>Package created for:</span>
                                    </td>
                                    <td>
                                        {self.props.getAttributeBySalesAgreement(agreementNumber, 'AGREEMENT_NAME')}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span style={{fontWeight: 'bold'}}>Package Name: </span> &nbsp;
                                    </td>
                                    <td>
                                        {poNumber}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{paddingTop: '0px'}}>
                                        <span style={{fontWeight: 'bold'}}>Shipping Address:</span>
                                    </td>
                                    <td style={{paddingTop: '22px'}}>
                                        {shippingAddress.address1}<br />
                                        {shippingAddress.city}, {shippingAddress.state} {shippingAddress.zip}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <table id="editTable" className="dataTableType2 createOrderTableB milktoast" style={{width: '100%'}}>
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Description</th>
                                <th>Price</th>
                                <th>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                        {packageDetails.items.map((item, index) => {
                            return [<tr key={index}>
                                <td style={{width: '20%'}}>
                                    <p>{item.item}</p>
                                </td>
                                <td style={{width: '60%'}}>
                                    <p>
                                        {item.itemDescription}
                                    </p>
                                </td>
                                <td style={{width: '10%'}}>
                                    <p>{self.props.formatMoney(item.price, 0, ".", ",", false, "$")}</p>
                                </td>
                                <td>
                                    <p>{item.quantity}</p>
                                </td>
                            </tr>,
                            item.relatedServices?
                                item.relatedServices.map((itm, ind) => {
                                    if(itm.type === "BAG") return null;
                                    return <tr key={ind}>
                                        <td style={{width: '20%'}}>
                                            &nbsp; &nbsp; {itm.serviceId}
                                        </td>
                                        <td style={{width: '60%'}}>{itm.serviceName}</td>
                                        <td style={{width: '10%'}}>{self.props.formatMoney(itm.price, 0, ".", ",", false, "$")}</td>
                                        <td>
                                            {itm.quantity}
                                        </td>
                                    </tr>
                                }):
                            null
                            ]
                        })}
                        </tbody>
                    </table>
                    <br />
                    <div id="createpcklink">
                        <p className="floatLeft addNewPageParagraph">
                            <a className="bold uppercase" href="" onClick={this.handleRedirect.bind(this)}>CREATE ANOTHER PACKAGE</a>
                        </p>
                        <br /><br />
                    </div>
                </form>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
});

PackageConfirmation = connect(mapStateToProps, mapDispatchToProps)(PackageConfirmation);
export default PackageConfirmation;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Packages/packageConfirmation.js